import React, { useContext } from "react";
import { IconButton, Tooltip } from "@mui/material";
import Flag from "react-world-flags";
import { LanguageContext } from "./LanguageContext";

const LanguageSwitch = ({ color = "inherit", size = "medium", sx = {} }) => {
    const { translations, switchLanguage, language } = useContext(LanguageContext);

    const getCountryCode = (lang) => {
        switch (lang) {
            case "bs":
                return "BA";
            case "sr":
                return "RS";
            case "en":
                return "GB";
            default:
                return "BA";
        }
    };

    const getLanguageName = (lang) => {
        switch (lang) {
            case "bs":
                return translations.languageBosnian || "Bosanski";
            case "sr":
                return translations.languageSerbian || "Srpski";
            case "en":
                return translations.languageEnglish || "English";
            default:
                return translations.languageBosnian || "Bosanski";
        }
    };

    const iconSize = size === "small" ? 16 : size === "large" ? 28 : 20;

    return (
        <Tooltip title={`${translations.switchLanguage || "Switch language"} (${getLanguageName(language)})`}>
            <IconButton
                onClick={switchLanguage}
                color={color}
                sx={{
                    p: 1,
                    borderRadius: 2,
                    transition: "all 0.3s ease",
                    "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        transform: "scale(1.05)",
                    },
                    ...sx,
                }}
            >
                <Flag
                    code={getCountryCode(language)}
                    style={{ width: iconSize, height: iconSize, borderRadius: 4 }}
                />
            </IconButton>
        </Tooltip>
    );
};

export default LanguageSwitch;